import { render } from "./note-card-expand.vue?vue&type=template&id=49f672e8"
import script from "./note-card-expand.vue?vue&type=script&lang=js"
export * from "./note-card-expand.vue?vue&type=script&lang=js"

import "./note-card-expand.vue?vue&type=style&index=0&id=49f672e8&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__